<script>

export default {
    name: "BaseAccordion",
    props: {
      data: {
        type: Array,
      },
      theme: {
        type: String,
      },
    },
  computed: {
      getIconColor () {
        return this.theme === 'dark' ? '#D0D5DD' : '#000'
      }
  }
  }
</script>

<template>
    <div
        id="faq-accordion"
        class="base-accordion"
        :class="[theme === 'dark' ? 'theme-dark' : 'theme-light']"
    >
        <div v-for="(item, index) in data" :key="`acc-item${index}`" class="accordion-item">
            <h2 class="accordion-header">
                <button
                    class="accordion-button fw-semibold justify-content-between"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#collapse-${index}`"
                    aria-expanded="false"
                    :aria-controls="`collapse-${index}`"
                >
                    {{ item.question }}

                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="flex-shrink-0 ms-1 open-icon"
                        aria-hidden="true"
                    >
                        <path
                            d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                            :stroke="getIconColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="flex-shrink-0 ms-1 close-icon">
                      <path d="M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" :stroke="getIconColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  
                </button>
            </h2>
            <div
                :id="`collapse-${index}`"
                class="accordion-collapse collapse"
                data-bs-parent="#faq-accordion"
            >
                <div class="accordion-body" v-html="item.answer">
                </div>
            </div>
        </div>
    </div>
</template>
